module.exports = __webpack_public_path__ + "static/media/修改信息.6f4c744f.svg";